<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/informatica/fondo-informatica.jpg" style="background-image: url('assets/img/informatica/fondo-informatica.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            Componente de Sistemas/GIS Proyecto IOARR
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="team-area-wrapper bg-offwhite pt-80 pt-md-80 pt-sm-60 pb-80 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/gerencia/fondo-gerencia.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">

          <div class="col-lg-6 text-center">
              <div class="speaker-member-wrap" style="margin-top:-20px;">
                <figure class="speaker-thumbnail">
                    <img src="assets/img/informatica/jennifer.jpg"
                        alt="GERENCIA DEL CENTRO HISTÓRICO"
                        style="width: 300px; display: block; margin: 0 auto;">
                </figure>
                <div class="speaker-info">
                    <h3 style="text-align: center;">Ing. Jennifer Farfán Luna</h3>
                    <h6 class="designation mb-20" style="text-align: center;">COORDINADORA COMPONENTE SISTEMAS/GIS</h6>
                </div>
            </div>
          </div>
          <div class="col-lg-6 text-center">
              <div class="">
                  <h2>COMPONENTE SISTEMAS/GIS</h2>
                  <p class="m-0" style="font-size: 16px; line-height: 1.9;">A TRAVÉS DE LA GERENCIA DE CENTRO HISTÓRICO Y EL PROYECTO ADQUISISCIÓN DE
                  SISTEMA DE INFORMACION PARA LA OPTIMIZACIÓN DEL SERVICIO DE CATALOGACIÓN DE INMUEBLES DEL CENTRO HISTÓRICO
                  se tiene el componente de sistemas/GIS el cual desarrolló de un sistema de catalogación web que permite la preservación de la información
                  de catalogación de inmuebles urbanos, inmuebles religiosos y ambientes urbanos, asi como tambien nos
                  permite la creación de fichas arquitectónicas, arquitectónica fotográfica, arqueológicas, arqueológica fotográfica,
                  históricas y legales de cada inmueble.
                  Para ello el componente se dividió en tres sub áreas que permitieron el desarrollo de cada una de las partidas asignadas para su ejecución y cumplimiento,
                  estas sub áreas se dividieron de la siguiente manera: Migración de datos de las fichas excel de catalogación, Sistematización Planimétrica,
                  Desarrollo de software del sistema de catalogación y desarrollo de la plataforma web.

                  </p>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- <div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/informatica/informatica20.jpg" class="btn-img-gallery">
                      <img src="assets/img/informatica/informatica20.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica21.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica21.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/informatica/informatica22.jpg" class="btn-img-gallery">
                      <img src="assets/img/informatica/informatica22.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica23.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica23.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica24.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica24.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica25.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica25.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica26.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica26.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica27.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica27.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica28.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica28.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica29.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica29.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica30.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica30.jpg" alt="Portfolio">
                </a>
              </figure>

          </div>
      </div>
  </article>
</div> -->
<section id="landing-service-area-wrapper" class="pt-68 pt-md-26 pt-sm-20 pb-114 pb-md-76 pb-sm-56" style="background-image: url('/assets/img/fondo-leyenda-catalogacion11.png'); ">
  <div class="container">

    <div class="row">
      <div class="col-lg-12 text-center" style="margin-bottom:-60px;">
        <div class="section-title-wrap">
          <h3 style="color:white">Partidas del Componente informatica</h3>
        </div>
      </div>
      <!-- Single Service Item #1 -->
      <div class="col-md-12 col-lg-12">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>DISEÑO, IMPLEMENTACIÓN Y SOPORTE DE BASE DE DATOS GEOGRÁFICA Y DE CATALOGACIÓN</h3>
            <p class="m-0">
              En base a la información recopilada de las fichas Arqueología, Arquitectónica y Patrimonio Inmaterial se diseñara la estructura de la base de
              Datos Geoespacial, diseño conceptual, lógico y físico, seguidamente se procederá a implementar la base de datos en el Gestor de Dase de datos
              PostgreSQL con el complemento PostGIS.
              <br>
              Generar el diseño de una base de datos de información geográfica de catalogación del centro histórico de la ciudad del Cusco, con el objetivo
              de que los propietarios y la población puedan acceder vía página web a los datos generales de los inmuebles.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>DISEÑO, IMPLEMENTACIÓN Y SOPORTE DE PROGRAMA PARA REGISTRO DE CATALOGACIONES  </h3>
            <p class="m-0">
              Con la base de datos espacial construida se procederá a implementar el sistema de registro de Catalogaciones, el cual será web y trabajara bajo
              la arquitectura Modelo, Vista y Template (MVT), arquitectura definida por el framework de desarrollo DJANGO.
            </p>
          </div>
        </div>
      </div>
      <!-- Single Service Item #2 -->
      <div class="col-md-12 col-lg-12">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>ELABORACIÓN DE LA CARTOGRAFÍA BASE ACTUALIZADA CATASTRAL DEL CENTRO HISTÓRICO.  </h3>
            <p class="m-0">
              Mediante esta partida se realizará la actualización de la cartografía existente de la catalogación de inmuebles a través de mapas y planos tanto en
              ArcGIS o similar como AutoCAD necesarias para tener información actualizada y verificada de los predios.
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>DISEÑO E IMPLEMENTACIÓN DE LA INFRAESTRUCTURA PLATAFORMA WEB.  </h3>
            <p class="m-0">
              Esta partida comprende el diseño e implementación de un portal web que tendrá acceso el público en general, el portal Web deberá ser amigable y
              dinámica al público en general, se utilizará mapas temáticos interactivos para la consulta de los inmuebles de catalogados y para el patrimonio inmaterial.
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
<div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/informatica/informatica14.jpg" class="btn-img-gallery">
                      <img src="assets/img/informatica/informatica14.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica15.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica15.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/informatica/informatica16.jpg" class="btn-img-gallery">
                      <img src="assets/img/informatica/informatica16.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica17.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica17.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica18.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica18.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica19.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica19.jpg" alt="Portfolio">
                </a>
              </figure>
          </div>
      </div>
  </article>
</div>

<div class="freelancer-service-area bg-offwhite pt-120 pt-md-80 pt-sm-60 pb-120 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-componentes11.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <div class="section-title-wrap layout--3">
          <h2>PRODUCTOS DEL COMPONENTE DE SISTEMAS/GIS</h2>
        </div>
        <p style="margin-top: -30px !important; margin-bottom: 30px">“OPTIMIZACIÓN DEL SISTEMA DE INFORMACIÓN DEL
          SERVICIO DE CATALOGACIÓN DE INMUEBLES DEL CENTRO HISTÓRICO, <br>DISTRITO DE CUSCO, PROVINCIA CUSCO,
          DEPARTAMENTO CUSCO”,</p>
      </div>
    </div>
    <div class="row mtn-30">
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-laptop" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">SISTEMA DE CATALOGACIÓN</h3>
            <p>Se desarrollo de un sistema de catalogación web que permite la preservación de la información a través del tiempo de la catalogación de inmuebles urbanos,
              inmuebles religiosos y ambientes urbanos del Centro Histórico del Cusco, a través del mismo podremos crear nuevas fichas arquitectónicas, arquitectónica fotográfica,
              arqueológicas, arqueológica fotográfica, históricas y legales de cada inmueble y realizar la verificación y control de calidad de los datos almacenados.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-file" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">MIGRACIÓN DE FICHAS CATALOGADAS</h3>
            <p>Se entregó la migración de cada una de las fichas excel catalogadas en los periodos 2010-2013, 2018, 2019-2021, recorriendo cada una de estas fichas a través
              del software de migración, el que nos pemite extraer de manera casi automática los datos consiganados en cada una de las fichas llenadas de cada inmueble urbano
              y migrarlas a la base de datos implementada para el sistema de catalogación, esto tanto para inmuebles urbanos, religiosos y ambientes urbanos.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-globe" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">Portal web</h3>
            <p>Se desarrollo el portal web de consulta, donde encontraremos mapas interactivos de la catalogación de inmuebles, patrimonio inmaterial
              y a su vez la ficha informativa que muestra el legado arquitectónico, arqueológico e histórico de cada inmueble del centro histórico.
              Así mismo en el portal podremos encontrar información sobre el plan maestro, Gerencia del centro histórico y los componentes de la IOARR.
            </p>
            <ul>
              <li>Colaboraciones:</li>
              <li><i class="fa fa-play"></i> •	LUIS GIUSSEPPE BEJAR CHACON - Fotografías.</li>
              <li><i class="fa fa-play"></i> •	ANDRES GERARDO PINEDA ESPINOZA - Ilustrador.</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-map" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">Planimetría de inmuebles</h3>
            <p>Se desarrolló la creación de la cartografía de cada inmueble catalogado con respecto a las fichas arquitectónicas y arqueológicas de las distintas catalogaciones realizadas
               teniendo toda esta información a disposición de la población
              en general mediante el portal web y a su vez en el portal del ARCGIS ONLINE de la Municipalidad del Cusco, para su consulta y revisión de cada mapa desarrollado.<br>
            </p>
            <ul>
              <li>Colaboraciones:</li>
              <li><i class="fa fa-play"></i> •	JOHAN ARNOLD DEL SOLAR CONDORHUANCA - ARCGIS</li>
              <li><i class="fa fa-play"></i> •	MIGUEL ANGEL GONZALES MORALES - ARCGIS</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="team-member-area">
  <div class="team-content-wrapper d-flex flex-wrap mtm-30">
    <!-- Start Single Team Member -->

    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/percy.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Ing. PERCY ROJAS AIQUIPA</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Coordinador Componente de Sistemas/GIS</h5>
          <p style="color:#d1d1d1;">Desarrollador Frontend y Mapas interactivos</p>

        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/cesar.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Ing. Geógraf. CESAR EDUARDO ECHENIQUE LESCANO</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Especialista GIS</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/ivan.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Ing. IVANOV TRIBEÑO HUAMANÑAHUI</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Analista de Base de datos</h5>
          <p style="color:#d1d1d1;">Desarrollador Backend</p>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/cintia.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Br. Ing. CINTIA YULISA FERNANDEZ GUEVARA </h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Desarrollador Backend</h5>
          <p style="color:#d1d1d1;">Analista y Desarrollador Backend Django</p>
        </figcaption>
      </figure>
    </div>
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/abel.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Br. Ing. JUSTO ABEL VARGAS PANTOJA</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Desarrollador Backend</h5>
          <p style="color:#d1d1d1;">Desarrollador Frontend y Backend Django</p>

        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member -->
  </div>
</section>
<section class="team-member-area">
  <div class="team-content-wrapper d-flex flex-wrap mtm-30">
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/kely.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Br. Ing. Geo. KELY SUNI MENDOZA</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Especialista GIS</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/yurico.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Br. Arq. YURICO LILI RIVERA CHALLCO</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Asistente GIS</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/albert.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Br. Ing. Geo. ALBERT CESAR NECOCHEA ORTIZ</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Asistente GIS</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/kathia.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Ing. KATYA JHISNEY AQUEHUA TARCO</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Especialista GIS</h5>
        </figcaption>
      </figure>
    </div>
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/informatica/johan.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Est. Ing. Geo. JOHAN ARNOLD DEL SOLAR CONDORHUANCA </h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Colaborador GIS</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member -->
  </div>
</section>

<section class="team-member-area bg-offwhite pt-120 pt-md-80 pt-sm-60 pb-120 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-rosario.png'); background-size: cover; background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-6 m-auto text-center">
        <div class="section-title-wrap">
          <h2>Equipo de trabajo</h2>
          <p class="mb-0">El componente de catalogación contó con el siguiente equipo de trabajo.</p>
        </div>
      </div><!-- End Section title -->
    </div>

    <div class="port-details-con-inner">
          <div class="single-post-details__footer m-0">
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Asistente Sistematización:</h5>
              </div>
              <div class="footer-item-right">
                <span>Ing. Informático MIGUEL ANGEL ZAPATA AYALA</span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Especialista GIS:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Ing. JORGE HUMBERTO URQUIZO CABALLERO </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Asistente Sistematización:</h5>
              </div>
              <div class="footer-item-right">
                <span>Ing. VICTOR ARMANDO OLIVARES BACA </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Colaborador GIS:</h5>
              </div>
              <div class="footer-item-right">
                <span>Est. Ing. Geo. MIGUEL ANGEL GONZALES MORALES</span>
              </div>
            </div>
          </div>
        </div>
  </div>
</section>
<div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/informatica/informatica01.jpg" class="btn-img-gallery">
                      <img src="assets/img/informatica/informatica01.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica02.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica02.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/informatica/informatica03.jpg" class="btn-img-gallery">
                      <img src="assets/img/informatica/informatica03.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica04.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica04.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica09.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica09.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica06.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica06.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica07.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica07.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica07.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica07.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica08.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica08.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica05.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica05.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica10.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica10.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica11.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica11.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica12.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica12.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/informatica/informatica13.jpg" class="btn-img-gallery">
                    <img src="assets/img/informatica/informatica13.jpg" alt="Portfolio">
                </a>
              </figure>
          </div>
      </div>
  </article>
</div>
